import { render } from "./AccessDeniedPage.vue?vue&type=template&id=557773cc&scoped=true&ts=true"
import script from "./AccessDeniedPage.vue?vue&type=script&lang=ts"
export * from "./AccessDeniedPage.vue?vue&type=script&lang=ts"

import "./AccessDeniedPage.vue?vue&type=style&index=0&id=557773cc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-557773cc"]])

export default __exports__